import { render } from "./SetField.vue?vue&type=template&id=c873ae36"
import script from "./SetField.vue?vue&type=script&lang=js"
export * from "./SetField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__